// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1y1sgxd2 {
  position: relative;
  text-align: center;
  border-top: 1px solid var(--_18w76bw28);
  width: 100%;
}
._1y1sgxd3 {
  line-height: var(--_18w76bw41);
  color: var(--_18w76bw2e);
  cursor: pointer;
}
._1y1sgxd3:hover {
  text-decoration: underline;
}
._1y1sgxd4 {
  display: inline-flex;
  align-items: center;
  gap: var(--_18w76bwc);
  margin-bottom: var(--_18w76bwg);
  height: auto;
}
@media screen and (min-width: 768px) {
  ._1y1sgxd0 {
    max-width: 460px;
    margin: 0 auto;
  }
  ._1y1sgxd1 {
    max-width: calc(100% - 170px);
  }
  ._1y1sgxd2 {
    max-width: 280px;
    margin-left: auto;
    margin-right: auto;
    margin-top: var(--_18w76bwb);
    margin-bottom: var(--_18w76bwg);
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;EACvC,WAAW;AACb;AACA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,+BAA+B;EAC/B,YAAY;AACd;AACA;EACE;IACE,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,4BAA4B;IAC5B,+BAA+B;EACjC;AACF","sourcesContent":["._1y1sgxd2 {\n  position: relative;\n  text-align: center;\n  border-top: 1px solid var(--_18w76bw28);\n  width: 100%;\n}\n._1y1sgxd3 {\n  line-height: var(--_18w76bw41);\n  color: var(--_18w76bw2e);\n  cursor: pointer;\n}\n._1y1sgxd3:hover {\n  text-decoration: underline;\n}\n._1y1sgxd4 {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--_18w76bwc);\n  margin-bottom: var(--_18w76bwg);\n  height: auto;\n}\n@media screen and (min-width: 768px) {\n  ._1y1sgxd0 {\n    max-width: 460px;\n    margin: 0 auto;\n  }\n  ._1y1sgxd1 {\n    max-width: calc(100% - 170px);\n  }\n  ._1y1sgxd2 {\n    max-width: 280px;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: var(--_18w76bwb);\n    margin-bottom: var(--_18w76bwg);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
